module.exports = __webpack_public_path__ + "img/icomoon-bold.d3152dc.svg";